<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import validatorRules from "@/utils/validator-rules.js";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import {addCoach, changeCoachState, deleteCoach, editCoach, getCoach, listCoach} from "@/api/coach/coach.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  coachName: null,
  phone: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listCoach(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.coachName = null
  formData.phone = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  {title: '名称', key: 'coachName', width: "120px", nowrap: true},
  {title: '状态', key: 'state', width: "150px", nowrap: true},
  {title: '联系电话', key: 'phone', width: "150px", nowrap: true},
  {title: '微信', key: 'wxId', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "100px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 获取详情信息
const getDetail = async (info) => {
  open.value = true
  try {
    dialogLoading.value = true
    const res = await getCoach(info.coachId)
    isEdit.value = true
    dialogLoading.value = false
    dialogForm.coachId = res.coachId
    dialogForm.coachName = res.coachName
    dialogForm.intro = res.intro
    dialogForm.phone = res.phone
    dialogForm.avatar = res.avatar
    dialogForm.wxId = res.wxId
    handleReviewPic([res.avatar])
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}
// 禁用教练
const banCoach = async (id) => {
  try {
    await changeCoachState(id, 0)
    ElMessage.success("禁用成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 禁用教练
const unBanCoach = async (id) => {
  try {
    await changeCoachState(id, 1)
    ElMessage.success("恢复成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}

/*删除操作对话框*/
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await deleteCoach(item.coachId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*新建/修改教练*/
// 是否为修改
const isEdit = ref(false)
// 新建教练弹窗状态
const open = ref(false)
// 对话框表单锚点
const dialogFormRef = ref()
// 对话框加载状态
const dialogLoading = ref(false)
// 对话框表单
const dialogForm = reactive({
  avatar: null,
  coachId: null,
  coachName: null,
  intro: null,
  phone:null,
  wxId: null,
})
// 对话框表单校验规则
const checkPhone = (rule, value, callback) => {
  if (value) {
    if (!validatorRules.isPhone(value)) {
      callback(new Error('手机号码格式不正确'))
    }
  }
  callback()
}
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张教练照片'))
  }
  callback()
}
const dialogRules = reactive({
  avatar: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  coachName: [
    {required: true, message: "请输入教练名称", trigger: "blur"},
  ],
  phone: [
    {validator: checkPhone, trigger: "blur"}
  ]
})
// 关闭对话框
const closeDialog = () => {
  open.value = false
  isEdit.value = false
  clearDialog()
}
// 确认新建教练
const submitDialog = () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      await handleSubmitDialog()
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
        appendTo: "#dialog"
      })
    }
  })
}
// 提交新建/编辑教练表单
const handleSubmitDialog = async () => {
  try {
    console.log("isEdit.value", isEdit.value)
    if (isEdit.value) {
      await editCoach(dialogForm.coachId, dialogForm)
    } else {
      await addCoach(dialogForm)
    }
    ElMessage.success(isEdit.value ? "修改教练成功" : "新建教练成功")
    await handleSearch()
    closeDialog()
  } catch (e) {
    console.log(e)
    closeDialog()
  }
}
// 清除对话框表单校验
const clearDialog = () => {
  dialogForm.coachId = null
  dialogForm.coachName = null
  dialogForm.intro = null
  dialogForm.phone = null
  dialogForm.wxId = null
  isEdit.value = false
  dialogFormRef.value.clearValidate()
}

/*上传图片组件相关*/
// 图片上传组件锚点
const boxUploadRef = ref()
// 处理图片列表删除
const handleImageRemove = (url) => {
  dialogForm.avatar = url[0]
  dialogFormRef.value.validateField("avatar")
}
// 处理图片上传成功
const handlePicSuccess = (url) => {
  dialogForm.avatar = null
  dialogForm.avatar = url[0]
  loading.value = false
  dialogFormRef.value.validateField("avatar")
}
// 处理图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList)
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="open = true" :disabled="!$handleHasBtnPermission('any', 'coach:add')">新建教练
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.coachName"
                        placeholder="请输入教练名"
                        label="教练名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.phone"
                        placeholder="请输入联系电话"
                        label="联系电话"
                        variant="outlined"
                        clearable
                        maxlength="11"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')"
                               :disabled="!$handleHasBtnPermission('all', 'coach:view')">搜索
                        </v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset"
                               :disabled="!$handleHasBtnPermission('all', 'coach:view')">重置
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.state="{ item }">
            <el-text :type="item.state === 1 ? 'success' : 'danger'" v-text="item.state === 1 ? '正常' : '禁用'"></el-text>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left flex_align_b">
              <el-popconfirm @confirm="unBanCoach(item.coachId)" :title="`确定恢复教练“${item.coachName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.state === 0"
                        class="box-item"
                        effect="dark"
                        content="恢复"
                        placement="left">
                      <v-icon class="cursor-pointer mg_r_1" icon="mdi-lock-open-variant-outline" color="success" v-show="$handleHasBtnPermission('all', 'clubActivityState:edit')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="banCoach(item.coachId)" :title="`确定恢复教练“${item.coachName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.state === 1"
                        class="box-item"
                        effect="dark"
                        content="禁用"
                        placement="left">
                      <v-icon class="cursor-pointer mg_r_1" icon="mdi-lock-outline" color="error" v-show="$handleHasBtnPermission('all', 'coachState:edit')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)"
                        v-show="$handleHasBtnPermission('all', 'coach:edit')"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除教练 “${item.coachName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close"
                              v-show="$handleHasBtnPermission('all', 'coach:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTFormDialog id="dialog" :open="open" :title="isEdit ? '编辑教练' : '新建教练'" :max-width="600">
    <template v-slot:content="{form}">
      <el-form
          ref="dialogFormRef"
          style="max-width: 100%"
          :model="dialogForm"
          :rules="dialogRules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          v-loading="dialogLoading"
      >
        <el-form-item label="教练照片：" prop="avatar">
          <BoxUpload ref="boxUploadRef" :ali-oss-path="'COACH_AVATAR_IMG_PATH'" :width="80" :height="80" :limit="1" :file-size="1" @progress="loading = true" @remove="handleImageRemove" @success="handlePicSuccess" :tipsAppendTo="'#dialog'"></BoxUpload>
        </el-form-item>
        <el-form-item label="教练名称：" prop="coachName">
          <el-input maxlength="10" show-word-limit v-model="dialogForm.coachName" placeholder="请输入教练名称"></el-input>
        </el-form-item>
        <el-form-item label="介绍：" prop="intro">
          <el-input type="textarea" maxlength="500" resize="none" :rows="5" show-word-limit v-model="dialogForm.intro" placeholder="请输入教练介绍"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input maxlength="11" show-word-limit v-model="dialogForm.phone" placeholder="请输入教练联系电话"></el-input>
        </el-form-item>
        <el-form-item label="微信号：" prop="wxId">
          <el-input maxlength="50" show-word-limit v-model="dialogForm.wxId" placeholder="请输入教练微信号"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="5" offset="7">
          <div class="flex_right">
            <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
            <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog" :disabled="!$handleHasBtnPermission('any', 'coach:add', 'coach:edit')">确定</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
</template>

<style scoped>

</style>
